import {
  AfterViewChecked,
  Component,
  computed,
  ElementRef,
  input,
  model,
  output,
  Signal,
  signal,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ziro-datatable-slider',
  imports: [CommonModule],
  templateUrl: './datatable-slider.component.html',
  styleUrl: './datatable-slider.component.scss',
})
export class DatatableSliderComponent implements AfterViewChecked {
  @ViewChild('slider', { static: true }) sliderRef: ElementRef;
  @ViewChild('pointer', { static: true }) pointerRef: ElementRef;

  readonly min = input(0);
  readonly max = input.required<number>();
  value = model.required<number>();
  readonly step = input(1);
  readonly disableDropDownOptions = input.required<boolean>();
  valueChange = output<number>();

  slider_width = signal<number>(0);
  pointer_width = signal<number>(0);
  sliderWidthWithOffset: Signal<number> = computed(() => this.slider_width() - 2 * (this.pointer_width() / 2));
  fontSize: Signal<string> = computed(() => (this.value() > 99 ? '0.6rem' : '0.8rem'));
  sliderProgressStyling: Signal<string> = computed(() => {
    const percentage = (this.value() / (this.max() - this.min())) * 100;
    return `linear-gradient(to right, #2DCCD3FF ${percentage}%, #adb5bd7a ${percentage}%`;
  });
  pointerLeftPosition: Signal<string> = computed(() => {
    const left = (this.value() / (this.max() - this.min())) * this.sliderWidthWithOffset();
    return `${left}px`;
  });

  ngAfterViewChecked(): void {
    if (this.sliderRef.nativeElement.offsetWidth !== this.slider_width()) {
      this.slider_width.set(this.sliderRef.nativeElement.offsetWidth);
      this.pointer_width.set(this.pointerRef.nativeElement.offsetWidth);
    }
  }

  updateValue($event: any): void {
    this.value.update(() => Number($event.target.value));
    this.valueChange.emit(this.value());
  }
}
